import React from 'react';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import CartUpsellContent from './CartUpsellContent';

const CartUpsell = (props) => (
  <Provider store={store}>
    <CartUpsellContent {...props} />
  </Provider>
);

export default CartUpsell;
